import React, { useState } from "react";
import "./Weather.css";
import axios from "axios";
import WeatherMain from "./WeatherMain";

export default function Weather(props) {
  const [city, setCity] = useState(props.defaultCity);
  const [weatherData, setWeatherData] = useState({ ready: false });
  function handleResponse(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
      city: response.data.name,
    });
  }
  function Search() {
    let apiKey = "9460f8b232cf9cdf7732eaa24fc723b3";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }
  function handleSubmit(event) {
    event.preventDefault();
    Search();
  }

  function handleCityInfo(event) {
    event.preventDefault();
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <input
            type="search"
            placeholder="Enter your city..."
            className="control"
            autoFocus="on"
            onChange={handleCityInfo}
          />{" "}
          <input type="submit" value="Search" className="btn btn-warning" />
        </form>
        <WeatherMain data={weatherData} />
      </div>
    );
  } else {
    Search();
    return "Loading...";
  }
}
